import { AxiosRequestConfig, AxiosResponse } from 'axios';

export class BaseApiClass {
	/** The bearer token to provide with each API call */
	token = "";

	/** The callback to call when a token expiry is detected (the default function body is a placeholder that is replaced) */
	expiryCallback = () => { console.debug("Token Expired"); }

	/** The callback to call when the API is succesfully called (the default function body is a placeholder that is replaced) */
	successCallback = () => { console.debug("API call"); }

	/**
	 * The main setup function
	 * @param token the bearer token to use
	 * @param tokenExpiryCallback the function to call when we detect the token has expired
	 * @param successCallback the function to call when we finish each successful API call
	 */
	public setTokenAndExpiryCallback(token: string, tokenExpiryCallback: () => void, successCallback: () => void) {
		this.token = token;
		this.expiryCallback = tokenExpiryCallback;
		this.successCallback = successCallback;
	}

	protected getBaseUrl(currentUrl: string): string {
		// Base URL is currently set in the constructor rather than this call
		return currentUrl;
	}

	protected transformOptions = async (options: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
		options.headers = {
			...options.headers,
			Authorization: 'Bearer ' + this.token,
		};
		return Promise.resolve(options);
	};

	protected transformResult(url: string, response: AxiosResponse, processor: (response: AxiosResponse) => any) {
		if (response && response.status === 401) {
			console.debug('401 Unauthorized detected');

			// Check if token is expired or invalid
			if (response.headers && (JSON.stringify(response.headers).indexOf("token-expired") > 0
				|| JSON.stringify(response.headers).indexOf("invalid_token") > 0)) {
				console.debug("Expired or invalid token detected - removing invalid token");
				if (this.expiryCallback != null)
					this.expiryCallback();
			}
		}
		if (response && response.status === 200) {
			if (this.successCallback != null)
				this.successCallback();
		}
		if (response && (response as any).isAxiosError === true) {
			console.debug('API call error detected:');
			console.debug('Response data = ' + response.data);
		}

		const processed = processor(response);
		return processed;
	}
}